import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/suppliers/dashboard',
}).lazy(() => import('./dashboard.lazy').then((d) => d.Route))
